module.exports = __webpack_public_path__ + "media/src/application/images/squares-262283d558ce0ea0c49682cb2d023ade.svg";